import config from "config/config";
import { ArchiveItem } from "models/ArchiveItem";
import { DeliveryFile } from "models/DeliveryFile";
import { DocumentUploadFile } from "models/DocumentUploadFile";
import { apiRequest, baseApiRequest } from "./apiInterceptor";
import {
  EmptyFoldersErrorContext,
  UploadErrorContext
} from "common/apiErrorHandling/customErrorHandlers";

type PreparedUploadResponse = { url: string; fileId: string };

export class ArchiveAPI {
  static async getArchiveFolderFiles(customerId: string, folderId: string) {
    const response = await apiRequest
      .get(config.api.archive.getArchiveFolderFiles(customerId, folderId))
      .send();

    return response.body;
  }

  static async restoreFile(itemId: string, customerId: string) {
    return await apiRequest
      .put(config.api.archive.restoreFile(customerId, itemId))
      .field("fileId", itemId);
  }

  static async markAsDeleted(itemId: string, customerId: string) {
    return await apiRequest
      .put(config.api.archive.markAsDeleted(customerId, itemId))
      .field("fileId", itemId);
  }

  static async fetchArchiveFolders(
    customerId: string,
    context: EmptyFoldersErrorContext
  ) {
    const request = apiRequest.get(config.api.archive.getArchive(customerId));

    (request as any).errorHandlerContext = context;

    return await request.send();
  }

  static async moveInArchive(
    item: ArchiveItem | DeliveryFile,
    customerId: string,
    path: string,
    name: string
  ) {
    return await apiRequest
      .put(config.api.archive.moveInArchive(customerId))
      .send({
        customerId,
        newPath: path,
        fileId: item.id,
        newName: name
      });
  }

  static async getUploadUrls(
    items: DocumentUploadFile[],
    customerId: string,
    path: string,
    context: UploadErrorContext
  ) {
    const request = apiRequest
      .post(config.api.archive.uploadToArchive(customerId))
      .send({
        path: path,
        files: items.map((item) => {
          return {
            ContentLength: item.file.size,
            ContentType: item.file.type,
            FileName: item.file.name
          };
        })
      });

    (request as any).errorHandlerContext = context;

    const response = await request;
    return response.body;
  }

  static async uploadToS3(
    preparedUploadResponse: PreparedUploadResponse,
    item: DocumentUploadFile
  ) {
    return await baseApiRequest
      .put(preparedUploadResponse.url)
      .set("Content-Type", item.file.type)
      .send(item.file);
  }
}
